import shapes from '@/assets/course-cover-shapes.svg'
import { coverGradientFor } from '@/lib/coverGradients'
import { cn } from '@/lib/utils'

interface Props {
  /** Номер курса: от него зависит градиент, чтобы у разных курсов цвета различались. */
  seed: number
  className?: string
}

/**
 * Обложка курса без картинки: брендовый градиент (набор — `coverGradients.ts`) и
 * четыре фигуры (звёздочка, песочные часы, листок, клевер). Фигуры цветные, но
 * легли на фон режимом luminosity — от цвета остаётся только яркость, поэтому на
 * любом градиенте они мягкие и перламутровые. Цвета — часть иллюстрации, а не
 * темы приложения.
 */
export const CoverPlaceholder = ({ seed, className }: Props) => (
  <div
    aria-hidden="true"
    style={{ backgroundImage: coverGradientFor(seed) }}
    className={cn('flex size-full items-center justify-center', className)}
  >
    <CoverShapes />
  </div>
)

/** Только фигуры, без своего фона — ложатся на чужой градиент (обложка инструкции). */
export const CoverShapes = () => (
  <img
    src={shapes}
    alt=""
    aria-hidden="true"
    className="h-[78%] w-auto mix-blend-luminosity"
    draggable={false}
  />
)
